var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7a90357a-4369-4849-9557-46518bcdaed2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m76.322,37.566h-9.183c-.552,0-1-.448-1-1s.448-1,1-1h9.183c.552,0,1,.448,1,1s-.448,1-1,1Z",
    style: {
      fill: "#95e2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.73,42.158c-.552,0-1-.448-1-1v-9.183c0-.552.448-1,1-1s1,.448,1,1v9.183c0,.552-.448,1-1,1Z",
    style: {
      fill: "#95e2c2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58.396,24.808c2.206,0,4,1.74,4,3.879s-1.795,3.879-4,3.879-4-1.74-4-3.879,1.795-3.879,4-3.879m0-4c-4.418,0-8,3.528-8,7.879s3.582,7.879,8,7.879,8-3.528,8-7.879-3.582-7.879-8-7.879h0Z",
    style: {
      fill: "#95e2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.897,43.192c3.025,0,5.52,2.256,5.806,5.132h-18.613c.286-2.876,2.781-5.132,5.806-5.132h7m0-4h-7c-5.408,0-9.834,4.358-9.834,9.685v3.447h26.668v-3.447c0-5.327-4.425-9.685-9.834-9.685h0Z",
    style: {
      fill: "#95e2c2"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.379,32.415c-.532,0-1-.111-1.288-.398h0c-.969-.969.068-4.01.614-4.556l7.189-7.189c.748-.749,2.052-.748,2.8,0l1.142,1.142c.772.772.772,2.028,0,2.8l-7.189,7.189c-.385.385-2.005,1.012-3.269,1.012Zm-.168-1.989h0Zm8.07-8.741l-7.161,7.189c-.113.186-.326.963-.41,1.523.563-.086,1.356-.311,1.586-.462l7.127-7.136-1.142-1.114Z",
    style: {
      fill: "#95e2c2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.728,11.676c2.206,0,4,1.74,4,3.879s-1.795,3.879-4,3.879-4-1.74-4-3.879,1.795-3.879,4-3.879m0-4c-4.418,0-8,3.528-8,7.879s3.582,7.879,8,7.879,8-3.528,8-7.879-3.582-7.879-8-7.879h0Z",
    style: {
      fill: "#95e2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.229,30.06c3.025,0,5.521,2.256,5.807,5.132h-18.614c.286-2.876,2.781-5.132,5.807-5.132h7m0-4h-7c-5.409,0-9.834,4.358-9.834,9.685v3.447h26.668v-3.447c0-5.327-4.426-9.685-9.834-9.685h0Z",
    style: {
      fill: "#95e2c2"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/Signin.db07faf5edee09588e774195259b2285.svg";
export { ForwardRef as ReactComponent };